module.exports = __webpack_public_path__ + "img/BWIN.3b39a6a7.svg";